/**
 * Validation Logic for Step 4 (HR Screening)
 */

import { JobPostFormData } from '../../../schemas/jobPostValidation';

/**
 * Validate individual screening question
 */
export const validateScreeningQuestion = (description: string): { valid: boolean; error?: string } => {
  const trimmed = description.trim();
  
  if (!trimmed) {
    return { valid: false, error: 'Screening question cannot be empty' };
  }
  
  return { valid: true };
};

/**
 * Ant Design form validation rules for screening question description
 */
export const validationRules = [
  {
    required: true,
    message: 'Please enter a screening question',
  },
];

